// extracted by mini-css-extract-plugin
module.exports = {"sectionPlan":"DingBeautyPlans_sectionPlan_2y2qQ"};